import React from 'react'
import Form from '../UI/Form'
import icon1 from '../../img/icons/icon-1.png'
import icon2 from '../../img/icons/icon-2.png'
import icon3 from '../../img/icons/icon-3.png'
import icon4 from '../../img/icons/icon-4.png'
import icon5 from '../../img/icons/icon-5.png'
import icon6 from '../../img/icons/icon-6.png'
import icon7 from '../../img/icons/icon-7.png'
import desktopMock from '../../img/hero/hero-img@3x.png'
import mobileMock from '../../img/hero/hero-img-mobile@2x.png'
import tabletMock from '../../img/hero/hero-img-mobile@3x.png'

const HeaderComponent = () => (
  <header className='w-screen bg-dark head-cmp'>
    <div className='hero-section p-5 container'>
      <div className='hero-row flex items-center'>
        <div className='flex-1 left-head-col'>
          <h1 className='head-title text-5xl text-white'>
            beauty is in the
            {' '}
            <br />
            {' '}
            <span className='line-through'>eye</span>
            {' '}
            ear of the beholder
          </h1>
          <h2 className='head-subtitle text-xl text-white'>Find your other half based on podcasts you listen to.</h2>
          <Form />
          <img className='mobile-mockup' src={mobileMock} alt='SoulCastMockup' />
          <img className='tablet-mockup' src={tabletMock} alt='SoulCastMockup' />
          <div className='flex items-center icons-list'>
            <p className='text-gray-500'>works with</p>
            <img className='icon-item' src={icon1} alt='SoulCastMockup' />
            <img className='icon-item' src={icon2} alt='SoulCastMockup' />
            <img className='icon-item' src={icon3} alt='SoulCastMockup' />
            <img className='icon-item' src={icon4} alt='SoulCastMockup' />
            <img className='icon-item' src={icon5} alt='SoulCastMockup' />
            <img className='icon-item' src={icon6} alt='SoulCastMockup' />
            <img className='icon-item' src={icon7} alt='SoulCastMockup' />
          </div>
        </div>
        <div className='flex-1 right-head-col'>
          <img className='desktop-mockup' src={desktopMock} alt='SoulCastMockup' />
        </div>
      </div>
    </div>
  </header>
)

export default HeaderComponent
